// Redesign (compact) [code]smith sidebar rows: 32px, 8px horizontal inset.

export const COMPACT_ROW_HEIGHT = 32;

// Transparent 2px y-borders + padding-box bg keep stacked 32px rows' fills apart.
export const REDESIGN_ROW_FILL_INSET_CLASS =
  "border-y-2 border-transparent bg-clip-padding";

export const COMPACT_SESSION_ROW_HEIGHT = 32;

export const COMPACT_SESSION_ITEM_ROW_CLASS = `flex h-8 items-center gap-1.5 px-2 rounded-[4px] ${REDESIGN_ROW_FILL_INSET_CLASS}`;

export const COMPACT_SESSION_ITEM_ROW_WRAP_CLASS = "";

export const COMPACT_SESSION_ITEM_INDICATOR_GUTTER_CLASS =
  "flex w-4 h-[22px] shrink-0 items-center justify-center";

export const COMPACT_SESSION_SECTION_HEADER_BOX_CLASS =
  "w-full flex items-center justify-between px-2";

export const COMPACT_SESSION_FOOTER_CLASS =
  "flex-shrink-0 mb-2 flex h-8 items-center justify-between px-2";

export const COMPACT_SESSION_TITLE_CLASS =
  "type-body-s-regular leading-[22px] truncate";

export const COMPACT_SESSION_META_CLASS =
  "shrink-0 type-body-s-regular leading-[22px] text-neutral-500 dark:text-neutral-400 whitespace-nowrap tabular-nums";

// Gradient layers = sidebar bg + the row's 4% hover tint, fading in over 20px.
export const COMPACT_SESSION_ACTIONS_CLASS =
  "absolute inset-y-0 right-0 flex items-center gap-1 pl-5 pr-1.5 opacity-0 group-hover:opacity-100 focus-within:opacity-100 [background-image:linear-gradient(to_right,transparent,rgba(0,0,0,0.04)_20px),linear-gradient(to_right,transparent,var(--sidebar)_20px)] dark:[background-image:linear-gradient(to_right,transparent,rgba(255,255,255,0.04)_20px),linear-gradient(to_right,transparent,var(--sidebar)_20px)]";

// Rail under the parent's chevron; children skip the indicator gutter.
export const COMPACT_SESSION_CHILDREN_CLASS = "relative ml-[15px] pl-[13px]";
// Chromium rounds a half-pixel `left` up to the next CSS pixel, drawing the
// rail 0.5px right of the chevron's center; a transform lands on the 2x device
// pixel instead. At 1x no crisp 1px line can center there, so it stays put.
export const COMPACT_SESSION_CHILDREN_RAIL_CLASS =
  "pointer-events-none absolute bottom-2 left-0 top-1 w-px bg-[var(--color-border)] [@media(min-resolution:2dppx)]:translate-x-[0.5px]";

export const COMPACT_FOCUS_RING_CLASS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--focus-border)]";
